import BreadcrumbsMUI from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { NavLink } from 'react-router-dom';

interface IProps {
  navList: INavItem[];
  currentPage: string;
}

interface INavItem {
  url: string;
  name: string;
}

function Breadcrumbs({ navList, currentPage }: IProps) {
  return (
    <BreadcrumbsMUI aria-label='breadcrumb'>
      {navList.map((item: INavItem, index: number) => (
        <NavLink key={index} to={item.url}>
          <Link color='inherit'>{item.name}</Link>
        </NavLink>
      ))}
      <Typography color='textPrimary'>{currentPage}</Typography>
    </BreadcrumbsMUI>
  );
}

export default Breadcrumbs;
